export default {"src":"/_next/static/media/bbc.3b4c49d8.svg","height":108,"width":108,"blurWidth":0,"blurHeight":0};